/***
 * Configuration for Authentication Routes
 *
 * Login Route
 * Password Routes
 ***/

/* ----- Views ----- */

// Login
import Login from "@/pages/Dashboard/Pages/Login";

// Password
import PasswordForgotten from "@/pages/Dashboard/Pages/PasswordForgotten";
import PasswordReset from "@/pages/Dashboard/Pages/PasswordReset";

/* ----- ----- ----- ----- ----- ----- ----- */

const authenticationRoutes = [
    {
        path: 'login',
        name: 'Login',
        component: Login,
        meta: {
            route: {
                label: 'Connexion'
            },
        },
    },
    {
        path: 'password/forgot',
        name: 'Password Forgot',
        component: PasswordForgotten,
        meta: {
            route: {
                label: 'Mot de passe oublié'
            },
        },
    },
    {
        path: 'password/forgot/:token',
        name: 'Password Reset',
        component: PasswordReset,
        meta: {
            route: {
                label: 'Modification du mot de passe'
            },
        },
    },
]
export default authenticationRoutes